import { Breadcrumb, Typography, Button, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import lang from "src/lang";
import UsersTable from "./UsersTable";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Users: React.FC = () => {
  const navigate = useNavigate();
  const handleAddRoleClick = () => {
    navigate("/modules/setting/users/add");
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("setting", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>
          {lang.get("setting", ["User Management"])}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("setting", ["Users"])}</Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("setting", ["Users"])}
      </Title>

      {/* Filter and Actions */}
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddRoleClick}
          >
            {lang.get("setting", ["New User"])}
          </Button>
        </Col>
      </Row>

      {/* Table */}
      <UsersTable />
    </div>
  );
};

export default Users;
